import {
  artworkCard,
  artworkLimiter,
  artworkOrder,
  featuredVideo,
  getBody,
  howToInfo,
  image,
  internationalizedArrayField,
  internationalizedField,
  internationalizedStringField,
  link,
  myPortfolioBanner,
  notification,
  reportCard,
} from '~/schemas/common'
import { metaQuery } from '~/utils/seo'
import { resolveUrlLinksWithTranslation, urlQuery } from '~/utils/urlResolver'

export const artworkQuery = (limiter: any, scorer: any = '', lang = 'en') => {
  return `*[_type == 'artwork' && (slug.current == $slug || $slug in _pastSlugs) && references(*[_type == 'artist' && slug.current == $artistSlug]._id) ${limiter}] ${scorer}[0]{
    ${urlQuery},
    ${metaQuery('artwork')},
    "artworkId": _id,
    "video": video->{
      ${featuredVideo}
    },
    "heroProps": {
      title,
      ...artist->{
        "artist": {
          "name": name,
          "id": _id,
          "tierLevel": tierLevel
        },
        "artistSlug": slug.current,
        "expert": expert-> {
          "name": name,
          "bio": ${internationalizedArrayField('description', lang)},
          "jobTitle": ${internationalizedStringField('jobTitle')},
          "email": email,
          "image": image,
          "slug": slug.current
        }
      },
      ${image},
      signed,
      ...formatDescription->{
        "format": name
      },
      year,
      editionSize,
      ...medium->{
        "medium": name
      },
      condition,
      dimensions,
      ...genre->{
        "genre": ${internationalizedField('name')},
        "genreId": _id
      },
      poa,
      listPriceMin,
      listPriceMax,
      listPriceMinValues,
      listPriceMaxValues,
      aagr,
      buyTicketsCount,
      sellTicketsCount,
      ownedTicketsCount,
    },
    "valueText": ${internationalizedArrayField('valueText', lang)},
    "banner": *[_type == 'banner' && showOnHomepage != true && references(^.artist->_id)] | order(_createdAt desc)[0]{
      title,
      "subtitle": body,
      "images": {
        image
      },
      "textMask": applyOverlay,
      ${link}
    },

    "longDescription1": ${internationalizedArrayField('longDescription1', lang)},
    "longDescription2": ${internationalizedArrayField('longDescription2', lang)},
    "artist": {
      ...artist->{
        _id,
        "slug": slug.current,
        "about": about[_key=="${lang}"][0].value[] ${resolveUrlLinksWithTranslation(lang)}
      }
    },
    "formatId": formatDescription->_id,
    "collection": {
      ...collection->{
        _id,
        "title": title,
        "slug": slug.current,
        "collectionTaxonomy": customTaxonomy,
        "relatedCollectionArtworks": *[_type == 'artwork' && defined(collection) && slug.current != $slug && collection._ref == ^._id && ${artworkLimiter}] | ${artworkOrder} [0...20]{
          ${artworkCard}
        }
      }
    },
    "fallbackRelatedArtworks": *[_type == 'artwork' && artist._ref == ^.artist._ref && ${artworkLimiter}] | ${artworkOrder} [0...12] {
      ${artworkCard}
    },
    ${myPortfolioBanner}
    ${howToInfo}
    ${getBody(lang)},
    ${notification},
    "featuredReports": array::unique(
      *[_type == 'report' && _id == ^.collection->relatedReport->_id ${limiter}]{
        ${reportCard}
      }
      + *[_type == 'report' && ^.artist->_id in feedRelatedArtists[]._ref && _id != ^.collection->relatedReport->_id ${limiter}] | order(publishedDate desc){
        ${reportCard}
      }
      + *[_type == 'report' && !defined(feedRelatedArtists) && _id != ^.collection->relatedReport->_id ${limiter}] | order(publishedDate desc) [0...4]{
        ${reportCard}
      }
    )[0...4]
}`
}
